import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
export function Hero() {
  return <section id="anasayfa" className="relative text-white" style={{
    backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/2oXeeQEynbRqaGc5FCHYBk/tahausta.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '450px',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-141">
      <div className="absolute inset-0 bg-black bg-opacity-0" data-id="element-142"></div>
      <div className="container mx-auto px-4 py-16 relative z-10 h-full flex items-center" data-id="element-143">
        <div className="max-w-xl text-left" data-id="element-144">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-145">
            Sakarya'nın En İyi Dizel Araç Ustası
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-green-500" data-id="element-146">
            Taha Usta
          </h2>
          <p className="text-xl mb-6" data-id="element-147">
            Hızlı, kaliteli ve uygun fiyatlı bakım ve onarım hizmetleri.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-148">
            <a href="https://wa.me/905322847563" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-green-600 text-white font-bold px-6 py-3 rounded-md hover:bg-green-700 transition text-lg border-2 border-white" data-id="element-149">
              <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-150" />
              <span data-id="element-151">WhatsApp'dan iletişime geçin</span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}